export const isExpiryDateValid = (expiryDate) => {
  const month = expiryDate.split('/')[0]
  const year = expiryDate.split('/')[1]
  // Check that month is between 01 and 12
  if (month < 1 || month > 12) return false
  // Check that the year is a two-digit number
  if (year && year.length !== 2) return false
  return true
}

export const isCardNumberValid = (cardNumber) => {
  return cardNumber.length >= 13
}

export const isCvvValid = (cvv) => {
  return cvv.length === 3
}
